<template>
  <div class="page">
    <div class="highlight">
      <div class="highlight-top">
        <div class="highlightTitle">{{ props.data.titleCn }}</div>
        <div class="highlightEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="highlight-bottom">
        <img :src="props.data.imgUrl" alt="" />
        <div class="bottom-list">
          <div class="list-item" :style="{ 'margin-top' : item.marginTop + 'px'}" v-for="(item, index) in props.data.list" :key="index">
            <div class="item-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .highlight {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .highlight-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .highlightTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .highlightEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .highlight-bottom{
      width: 100%;
      position: relative;
      img{
        width: 100%;
      }
      .bottom-list{
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        gap: 52px;
        .list-item{
          width: 203px;
          margin-left: 30px;
          .item-content{
            width: 100%;
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: 400;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: justify;
            text-transform: uppercase;
          }
        }
      }
    }
  }
}
</style>
